/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './not-found-page.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/not-found/not-found-page.component';
const styles_NotFoundPageComponent:any[] = [i0.styles];
export const RenderType_NotFoundPageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_NotFoundPageComponent,data:{}});
export function View_NotFoundPageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['404 Page Not Found']))],(null as any),(null as any));
}
export function View_NotFoundPageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'not-found-page',
      ([] as any[]),(null as any),(null as any),(null as any),View_NotFoundPageComponent_0,
      RenderType_NotFoundPageComponent)),i1.ɵdid(49152,(null as any),0,i2.NotFoundPageComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const NotFoundPageComponentNgFactory:i1.ComponentFactory<i2.NotFoundPageComponent> = i1.ɵccf('not-found-page',
    i2.NotFoundPageComponent,View_NotFoundPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvbm90LWZvdW5kL25vdC1mb3VuZC1wYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9ub3QtZm91bmQvbm90LWZvdW5kLXBhZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvbm90LWZvdW5kL25vdC1mb3VuZC1wYWdlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvbm90LWZvdW5kL25vdC1mb3VuZC1wYWdlLmNvbXBvbmVudC50cy5Ob3RGb3VuZFBhZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aDE+NDA0IFBhZ2UgTm90IEZvdW5kPC9oMT4iLCI8bm90LWZvdW5kLXBhZ2U+PC9ub3QtZm91bmQtcGFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBSTthQUFBOzs7b0JDQUo7TUFBQTtzQ0FBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/not-found/not-found-page.component.ngfactory.ts